import React, { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'

import './Login.css'

const   Login = () => {

    const emailValue = useRef()
    const passwordValue = useRef()

    const [isLoggedIn, setIsLoggedIn] = useState(false)


    const loginSubmitHandler = async event => {
        event.preventDefault()

        const enteredEmail = emailValue.current.value 
        const enteredPassword = passwordValue.current.value

        const requestBody = {
            email: enteredEmail,
            password: enteredPassword,
          };

        await fetch(process.env.REACT_APP_BACKEND_URL + '/user/login',{
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        }
        ).then(response => {

            if (!response.ok) {
                throw new Error(`Invalid email or password`+ requestBody.password);
            } 
            
            setIsLoggedIn(true)
            
        })
        .then(data => { 
           console.log(data)   
        })
        .catch(error => console.error(error));
    }
    
    if(isLoggedIn) {
        return <Navigate to='/remove-user' />
    }
    
    return (
        <form onSubmit = {loginSubmitHandler}>
            <div className='container'>
                <div className='header'>
                    <div className='text'>OccuProf Admin</div> 
                </div>
                <div className='inputs'>
                    <div className='input'>
                        <img src='' alt='' />
                        <input type='email' placeholder='Email' ref={emailValue} />
                    </div>
                    <div className='input'>
                        <img src='' alt='' />
                        <input type='password' placeholder='Password' ref={passwordValue} />
                    </div>
                </div>
                <div className='submit-container'>
                    <div className='submit' onClick={loginSubmitHandler}>LOGIN</div>
                </div>
            </div>
        </form>
    )
}

export default Login